import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LoadingButton from "../../components/LoadingButton";

interface CreateKeyDialogProps {
  open: boolean;
  onClose: () => void;
  onCreate: (name: string) => Promise<void>;
  loading?: boolean;
}

export default function CreateKeyDialog({ open, onClose, onCreate, loading = false }: CreateKeyDialogProps) {
  const [name, setName] = useState("");

  const handleCreate = async () => {
    const trimmed = name.trim();
    if (trimmed) {
      await onCreate(trimmed);
      setName("");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        Create API Key
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Key Name"
          type="text"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <LoadingButton 
          onClick={handleCreate} 
          loading={loading}
          disabled={!name.trim()}
          variant="contained"
        >
          Create
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}